import { semanticThemeTokens } from "@appretio/ui-kit";

export const COLOR_PALETTE = Object.values(
  semanticThemeTokens.dataTable.row.colorPalette
);
